define('global',[
  'jquery',
  'lib/util/tda.config',
  'lib/util/tda.context',

  // side effect includes
  'bootstrapCollapse',
  'bat'
], function (
  $,
  tdaConfig,
  tdaContext
) {
  'use strict';

  // Bootstrap collapse binding
  // BAT-3001 animate bottom filters LIs in dropdown
  // filterSlide animation located in _styleguide.scss
  // TODO: move out of here (src/lib/animations/filters.animations) maybe
  $('#filters-panel').on('show.bs.collapse', function (e) {
    var $target = $(e.target);
    var inAnim = $target.data('inAnimation');
    var $buttons = $target.parent('li').nextAll('li').find('button:first');
    var collapseDelay = 350;
    var animDelay = 50;
    var animDuration = 250;

    // Do some calculations
    var offsets = $buttons.length - 1;
    var offsetDelay = offsets * animDelay;
    var offsetAnimDuration = offsetDelay + animDuration;

    // We need to be able to reduce the size of the boxes at the same
    // rate that we grow them... so figure out the minimum offset
    if (offsetAnimDuration > collapseDelay) {
      animDelay = (collapseDelay - animDuration) / offsets;
      offsetDelay = offsets * animDelay;
      offsetAnimDuration = offsetDelay + animDuration;
    }

    if (inAnim) {
      // This should be happening buttons length * animDelay ms in

      // We are in the last animation already by animDelay ms
      // We have collapseDelay ms to finish closing the expanded items
      var delay = Math.max(collapseDelay - offsetAnimDuration, 0);

      // Prep the end animation
      setTimeout(function () {
        $buttons.each(function (idx) {
          var $this = $(this);
          $this
            .addClass('filterSlideOut')
            .removeClass('filterSlideIn')
            .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
              $this.removeClass('filterSlideOut');
            });
        });
      }, delay);

      // All done
      $target.data('inAnimation', false);
      return;
    } else {
      // Stop the slide open so we can call it later
      e.preventDefault();
    }

    // Flag we are in an animation
    $target.data('inAnimation', true);

    // Apply the animation updates
    $buttons.each(function (idx) {
      $(this)
        .css('animation-delay', ((offsets - idx) * animDelay) + 'ms')
        .addClass('filterSlideIn');
    });

    setTimeout(function () {
      $target.collapse('show');
      $target.prev().attr('aria-expanded', 'true');
    }, $buttons.length * animDelay);

  });

  $('#filters-panel').on('hide.bs.collapse', function (e) {
    var $target = $(e.target);
    $target.prev().attr('aria-expanded', 'false');
  });

  // BAT-3146.these elements do not have any js, or context from which to dismiss loader
  // handles 404 and national homepage.
  if ($('div[data-component-name="NationalCTAs"]').length) {
    window.bat.util.loader.hideLoader();
  }

  // CHI-154 Add for https analytics fix
  $('head').append('<meta name="referrer" content="origin-when-crossorigin">');

  // BAT-2492 Canonical SEO links for toyota-safety-sense pages
  if (window.location.pathname.indexOf('toyota-safety-sense') > -1) {
    $('head').append('<link rel="canonical" href="https://www.buyatoyota.com' + window.location.pathname + '" />');
  }

  // BAT-3141 SEO Page Titles
  function updateTitle() {
    var txtTitle = $.trim(document.title);
    var titleTestRegex = /.*BuyaToyota\.com$/i;
    var regionUrl = 'BuyaToyota.com';
    var regionText = tdaContext.getReadableContext(tdaConfig.tda.code)

    if (tdaConfig.tda.code != 'WWW') {
      if (window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1') {
        // Hate that dev stuff is here, but needed
        regionUrl = '** DEVELOPMENT ** | ' + regionText;
      } else {
        regionUrl = regionUrl + '/' + regionText;
      }
    }

    if (!titleTestRegex.test(txtTitle)) {
      // We don't have the standard buyatoyota.com suffix
      txtTitle += ' | ' + regionUrl;
    } else {
      var matches = txtTitle.match(/^(.*)\| ?([^|]*?)\.?(Buy[aA]Toyota\.com)$/i);
      // This should always result in a match if the previous test passed,
      // but better safe then sorry.
      if (matches) {
        txtTitle = matches[1] + ' | ' + regionUrl;
      }
    }
    document.title = txtTitle;
  }
  updateTitle();

  // overwrite the one that Bootstrap adds
  var head = document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.appendChild(document.createTextNode('body{opacity:1!important}'))
  head.appendChild(style);

  // The remainders were previously found in require-config.js
  // TODO: move to proper spot, which is...?
  setTimeout(function () {
    $('#dealer-content').find('button').on('click', function () {
      $(this).submit();
    });
  }, 3000);

  // TODO: move to better spot. Should still be in use if TDA has nav-links configured.
  // Currently in use on /tristateeast/
  // configure in preprod and test. These look super ghetto as-is anyway...
  var bodyWidth = $('body').width();
  $('#nav-links').css('transform', $('div.card:eq(0)').css('transform'));
  $('#nav-links').css('width', '96%');
  $('#nav-links').find('a').css('border-top', 'none');
  $('#nav-links').find('ul').css('border-bottom', 'none');
  $('#nav-links').find('ul').css('margin-left', '23px');
  $('#nav-links').find('ul').css('width', '80%');

  $('#nav-links').find('ul').css('border-top', '2px solid #ccc');
  $('#nav-links').css('border-bottom', 'none');

  if (bodyWidth >= 500) {
    $('#nav-links').css('width', '87%');
    $('#nav-links').find('ul').css('width', '80%');
  }

  if (bodyWidth < 500) {
    $('#nav-links').css('width', '77%');
    $('#nav-links').find('ul').css('width', '80%');
    $('#nav-links').find('ul').css('margin-left', '13px');
  }

  /*! Normalized address bar hiding for iOS & Android (c) @scottjehl MIT License */
  // TODO: is this still a thing. Leaving in place as it outputs height on body tag
  // may have ramifications if removed willy nilly
  var hideAddressBar = function () {
    var doc = window.document;
    // If there's a hash, or addEventListener is undefined, stop here
    if (!location.hash && window.addEventListener &&((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/mobile/i)) )) {
      // scroll to 1
      window.scrollTo(0, 1);
      var scrollTop = 1;
      var getScrollTop = function () {
        return window.pageYOffset || doc.compatMode === "CSS1Compat" && doc.documentElement.scrollTop || doc.body.scrollTop || 0;
      };

      var bodycheck = setInterval(function () {
        if (doc.body) {
          clearInterval(bodycheck);
          scrollTop = getScrollTop();
          setBodyHeightAndScroll();
        }
      }, 15);

      window.addEventListener('orientationchange', function () {
        setTimeout(function () {
          setBodyHeightAndScroll();
        }, 0);
      });
    }

    // doc height must be taller than viewport or we aren't allowed to scroll.
    // Temporarily making the body taller than it needs to be
    var setBodyHeightAndScroll = function () {
      var tempHeight = screen.height;
      var body = document.getElementsByTagName('BODY')[0];
      body.style.height = (tempHeight + 10) + 'px';
      window.scrollTo(0, scrollTop === 1 ? 0 : 1);
      fixHeightIOS();
    };

    var fixHeightIOS = function () {
      if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/mobile/i))) {
        var body = document.getElementsByTagName('BODY')[0];
        body.style.height = window.innerHeight + 'px';
      }
    };
  };

  hideAddressBar();
});

